import { SOCKET_DATA, UPDATE_DESKTOP_MODE, UPDATE_RESTAURANT_REVIEWS, UPDATE_WISHLIST_CART_COUNT } from "../actionTypes/generalTypes";

const initalState = {
  isDesktopMode: true,
  isCountUpdated: {},
  reviews: {},
  socketData: {}
};

export function generalReducer(state = initalState, action) {
  switch (action.type) {
    case UPDATE_DESKTOP_MODE: {
      return {
        ...state,
        isDesktopMode: action.payload,
      };
    }
    case UPDATE_WISHLIST_CART_COUNT: {
      return {
        ...state,
        isCountUpdated: {},
      };
    }
    case UPDATE_RESTAURANT_REVIEWS: {
      return {
        ...state,
        reviews: action.payload,
      };
    }
    case SOCKET_DATA: {
      return {
        ...state,
        socketData: action.payload,
      }
    }
    default:
      return state;
  }
}
